import React from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
import HeroImage from '../svg/HeroImage';
import SvgCharts from '../svg/SvgCharts';

const Index = () => (
  <Layout>
    <section id="home" className="pt-20 md:pt-40">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left lg:w-1/2">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-none">
            UmpCast
          </h1>
          <p className="text-xl lg:text-2xl mt-6 font-light">
            Helping youth sports organizations pioneer youth referee programs
          </p>
          <p className="mt-8 md:mt-12">
            <Button size="lg">Join the Mailing List</Button>
          </p>
        </div>
        <div className="lg:w-1/2">
          <HeroImage />
        </div>
      </div>
    </section>
    <section id="features" className="py-20 lg:pb-40 lg:pt-48">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold">Main Features</h2>
        <div className="flex flex-col sm:flex-row sm:-mx-3 mt-12">
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-xl">Self Assignment</p>
              <p className="mt-4">
                UmpCast is designed as a hands-off solution for referee management. Umpires manage themselves, leaving managers only for emergency situations
              </p>
            </Card>
          </div>
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-xl">TeamSnap Sync</p>
              <p className="mt-4">
                UmpCast is synced with TeamSnap, meaning that you don't have to manually enter each and every game at the beginning of each season
              </p>
            </Card>
          </div>
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-xl">Issues</p>
              <p className="mt-4">
                UmpCast automatically creates issues for situations that require manager intervention. For example, last minute cancellations, unfilled games, etc.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
    <SplitSection
      id="services"
      primarySlot={
        <div className="lg:pr-32 xl:pr-48">
          <h3 className="text-3xl font-semibold leading-tight">Youth League Plan $200/season</h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            UmpCast will outline the process to start a junior officials program, handle payments, and sync to external scheduling services
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-32 xl:pl-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Small Organization Plan $400/season
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Auto-assignment for large batches of games, school billing features, and training videos and documents for assignors
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <section id="stats" className="py-20 lg:pt-32">
      <div className="container mx-auto text-center">
        <LabelText className="text-gray-600">Our Traction</LabelText>
        <div className="flex flex-col sm:flex-row mt-8 lg:px-24">
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="3" secondaryText="Youth Little Leagues" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="1" secondaryText="Amateur Sports Associations" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="200+" secondaryText="Registered Referees" />
          </div>
        </div>
      </div>
    </section>
    <section id="testimonials" className="py-20 lg:py-40">
      <div className="container mx-auto">
        <LabelText className="mb-8 text-gray-600 text-center">What leagues are saying</LabelText>
        <div className="flex flex-col md:flex-row md:-mx-3">
          {customerData.map(customer => (
            <div key={customer.customerName} className="flex-1 px-3">
              <CustomerCard customer={customer} />
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="container mx-auto my-20 py-24 bg-gray-200 rounded-lg text-center">
      <h3 className="text-5xl font-semibold">Ready to build your junior umpiring program?</h3>
      <p className="mt-8">
        <Button size="xl">Get Started Now</Button>
      </p>
    </section>
  </Layout>
);

export default Index;
